import { Typography } from "@mui/material";
import ErrorIcon from '@mui/icons-material/Error';

export default function NotFoundPage() {
    return (
        <div className={"flex flex-col items-center mx-auto mt-5 p-2 w-3/4"}>
            <ErrorIcon sx={{ fontSize: 80 }}></ErrorIcon>
            <Typography sx={{ fontSize: 60 }} className={"my-5 text-gray-500 font-medium"}>
                404
            </Typography>
            <Typography sx={{ fontSize: 40 }} className={"text-gray-400 font-light"}>
                Page Not Found!
            </Typography> 
        </div>
    )
}